export default __webpack_public_path__ + "static/media/proj16-cover.5a33ef8c.png";